<template>
  <div :class="$style.card" @click.prevent="onClick">
    <div :class="$style.header">
      <div :class="$style.profile">
        <PImage
          :image-object="item.thumbnail"
          sizes="xs:32px"
          :class="$style.thumbnail"
        />
        <RichText :text-params="item.info" :class="$style.info" />
      </div>

      <img src="@/assets/icons/socials/google-icon.svg" :class="$style.icon" />
    </div>
    <RichText :text-params="item.content" />
    <div v-if="item.score" :class="$style.score">
      <Star
        v-for="(ratio, idx) in ratioArray(item.score)"
        :key="idx"
        :ratio="ratio"
        :size="22"
      />
    </div>
  </div>
</template>

<script>
import RichText from '~/components/RichText'
import Star from '~/components/Star'

export default {
  name: 'GoogleReviewCard',
  components: { RichText, Star },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    parseScore(score) {
      return score.toString().replace('.', ',')
    },
    ratioArray(score) {
      return new Array(5).fill(0).map((c) => {
        if (score > 1) {
          score -= 1
          return 1
        }
        const tmp = score
        score = 0
        return tmp
      })
    },
    onClick(e) {
      if (e.target.href) {
        return window.open(e.target.href, '_blank')
      } else if (this.item.link && this.item.link.url) {
        return window.open(this.item.link.url, '_blank')
      }
    },
  },
}
</script>

<style lang="scss" module>
.card {
  padding: 24px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.thumbnail {
  width: 32px;
  height: 32px;
  margin-right: 16px;
  border-radius: 16px;
}

.profile {
  display: flex;
  align-items: center;
  width: 100%;
}
.icon {
  width: 22px;
  height: 22px;
}
.info {
  color: $gray-600;
  strong {
    @include typo-body;
    color: $gray-800;
  }
}
.score {
  display: flex;
  margin-top: 25px;
}
</style>
